import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'capitalize',
  standalone: true,
})
export class CapitalizePipe implements PipeTransform {
  transform(sentance: string | null | undefined): string {
    if (sentance == null || !sentance.length) {
      return '';
    }
    return sentance.charAt(0).toUpperCase() + sentance.slice(1);
  }
}
